import React, { PureComponent } from 'react'
import { Table } from 'react-bootstrap'
import { formatTimeString } from '../../utils/formatters'
import SimpleModal from '../simple_modal'

class ErrorMessageTable extends PureComponent {
  constructor(props) {
    super(props)
    this.state = { content: null, isOpen: false, collapsed: true }
  }

  closeModalDialog = () => {
    this.setState({ isOpen: false, content: null })
  }

  static getErrors = (userTx) => {
    let errors = userTx.errors
    if (userTx.transaction_identity) {
      if (userTx.transaction_identity.errors && userTx.transaction_identity.errors.length) {
        errors = errors.concat(userTx.transaction_identity.errors)
      }
      if (userTx.transaction_identity.identity_documents) {
        for (let i = 0; i < userTx.transaction_identity.identity_documents.length; i++) {
          if (
            userTx.transaction_identity.identity_documents[i].errors &&
            userTx.transaction_identity.identity_documents[i].errors.length
          ) {
            errors = errors.concat(userTx.transaction_identity.identity_documents[i].errors)
          }
        }
      }
    }
    return errors
  }

  static renderTable = (errors) => {
    return (
      <div className='section-shadow'>
        <Table striped bordered hover>
          <thead>
            <tr className='tbl-font-bold'>
              <th>ID</th>
              <th>Name</th>
              <th>Description</th>
              <th>Created</th>
            </tr>
          </thead>
          <tbody>
            {errors.map((error, i) => {
              return (
                <tr key={i}>
                  <td>{error.error_code.error_code_id}</td>
                  <td>{error.error_code.error_code_name}</td>
                  <td>{error.error_code.error_code_description}</td>
                  <td>{formatTimeString(error.created)}</td>
                </tr>
              )
            })}
          </tbody>
        </Table>
      </div>
    )
  }

  render() {
    const { errors } = this.props
    const showError = errors && errors.length

    return (
      <div className='ibox float-e-margins animated fadeIn mt-3'>
        <div style={{ borderRadius: '10px 10px 0 0' }} className='ibox-title'>
          <h5>On Hold/Decline Reasons</h5>
        </div>
        <div style={{ borderRadius: '0 0 10px 10px' }} className='ibox-content table-responsive'>
          {showError ? ErrorMessageTable.renderTable(errors) : 'N/A'}
          <SimpleModal
            isModalDialogOpen={this.state.isOpen}
            content={this.state.content}
            title='Error Code'
            close={this.closeModalDialog}
          />
        </div>
      </div>
    )
  }
}

export default ErrorMessageTable
